import { Component, OnInit } from "@angular/core";
import { PlaceHolderName } from "./common/constants";
import { AuthService } from "./auth/auth.service";
import { MigrationStore } from "./services/migration.store";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  readonly PlaceHolderName = PlaceHolderName;
  isAuthenticated$ = this.authService.isAuthenticated$;
  username$ = this.authService.username$;
  userPhotoUrl$ = this.authService.userPhotoUrl$;
  isDarkMode = false;

  constructor(
    public authService: AuthService,
    public store: MigrationStore,
  ) {}

  ngOnInit(): void {}

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  getPlaceHolderValue(placeHolderName: PlaceHolderName): string {
    return this.store.getPlaceHolderValue(placeHolderName);
  }
}
